<div class="rd-widget widget-{{widgetConfig?.widgetId}}">
  <table data-id="widgetValuationResultsMarketValue" class="widget-large widgetNoTopBorder cellspacing-0 cellpadding-0" numberoflines="" *ngIf="widgetData && reflists" aria-hidden="true">
    <thead>
      <tr class="widget-ruller-large-two-columns-one-gap-fifty-percent">
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-space">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
      </tr>
    </thead>
    <tbody>
      <tr class="light-grey-line">
        <td colspan="8"><widget-label [widget]="this" [fieldName]="'inspectionDate'" [align]="'left'"></widget-label></td>
        <td colspan="25"><widget-value [align]="'right'">{{widgetData.inspectionDate | rdLocalizedDate}}</widget-value></td>
      </tr>
      <tr *ngIf="!editMode" class="white-line">
        <td colspan="8"><widget-label [widget]="this" [fieldName]="'inspector'" [align]="'left'"></widget-label></td>
        <td colspan="25"><widget-value [align]="'right'">{{widgetData.inspector | rdReflist:reflists['config_user']}}</widget-value></td>
      </tr>
      <tr *ngIf="editMode" class="white-line">
        <td colspan="8"><widget-label [widget]="this" [fieldName]="'inspector'" [align]="'left'"></widget-label></td>
        <td colspan="25">
          <kendo-dropdownlist [data]="reflists['config_user']" style="width:100%" class="widget-input-text"
                              textField="description"
                              valueField="oid"
                              [valuePrimitive]="true"
                              [(ngModel)]="widgetData.inspector"
                              (ngModelChange)="setDirtyFlag(true)">
          </kendo-dropdownlist>
        </td>
      </tr>
      <tr class="light-grey-line">
        <td colspan="8"><widget-label [widget]="this" [fieldName]="'inspectionType'" [align]="'left'"></widget-label></td>
        <td colspan="25"><widget-value [align]="'right'">{{widgetData.inspectionType}}</widget-value></td>
      </tr>
      <tr *ngIf="!editMode" class="white-line">
        <td colspan="8"><widget-label [widget]="this" [fieldName]="'limitations'" [align]="'left'"></widget-label></td>
        <td colspan="25"><widget-value [align]="'right'"><label hashtagsetvalue [widget]="this" [page]="page">{{widgetData.limitations}}</label></widget-value></td>
      </tr>
      <tr *ngIf="editMode" class="white-line">
        <td colspan="8"><widget-label [widget]="this" [fieldName]="'limitations'" [align]="'left'"></widget-label></td>
        <td colspan="25">
          <input type="text" [(ngModel)]="widgetData.limitations"    
          hashtag [widget]="this" [selectedTag]="hashTag" [widgetId]="this.widgetConfig.widgetId"
          [elType]="'text'" [page]="page"  
          [editMode]="editMode" 
          (setNewValue)="widgetData.limitations= $event;"
          id="limitations" class="widget-input-text gridster-item-content" (ngModelChange)="setDirtyFlag(true)" />
        </td>
      </tr>
      <tr *ngIf="!editMode" class="light-grey-line">
        <td colspan="8"><widget-label [widget]="this" [fieldName]="'appraiser'" [align]="'left'"></widget-label></td>
        <td colspan="25"><widget-value [align]="'right'">{{widgetData.appraiser | rdReflist:reflists['config_user']}}</widget-value></td>
      </tr>
      <tr *ngIf="editMode" class="light-grey-line">
        <td colspan="8"><widget-label [widget]="this" [fieldName]="'appraiser'" [align]="'left'"></widget-label></td>
        <td colspan="25">
          <kendo-dropdownlist [data]="reflists['config_user']" style="width:100%" class="widget-input-text"
                              textField="description"
                              valueField="oid"
                              [valuePrimitive]="true"
                              [(ngModel)]="widgetData.appraiser"
                              (ngModelChange)="setDirtyFlag(true)">
          </kendo-dropdownlist>
        </td>
      </tr>
      <tr *ngIf="!editMode" class="white-line">
        <td colspan="8"><widget-label [widget]="this" [fieldName]="'signOffDirector'" [align]="'left'"></widget-label></td>
        <td colspan="25"><widget-value [align]="'right'">{{widgetData.signOffDirector | rdReflist:reflists['config_user']}}</widget-value></td>
      </tr>
      <tr *ngIf="editMode" class="white-line">
        <td colspan="8"><widget-label [widget]="this" [fieldName]="'signOffDirector'" [align]="'left'"></widget-label></td>
        <td colspan="25">
          <kendo-dropdownlist [data]="reflists['config_user']" style="width:100%" class="widget-input-text"
                              textField="description"
                              valueField="oid"
                              [valuePrimitive]="true"
                              [(ngModel)]="widgetData.signOffDirector"
                              (ngModelChange)="setDirtyFlag(true)">
          </kendo-dropdownlist>
        </td>
      </tr>
    </tbody>
  </table>
</div>
